import branding from '@/config/branding';

export const DEPOT_HOST = branding.externalLinks.depotHost;
export const CRM_HOST = branding.externalLinks.crmHost;
